import { HugeiconsIcon, Icons } from "@/components/icons"

import { APP_ROUTES } from "@/constants/routes"
import { ImgLogoWithFullName } from "@/assets/images"
import { Link } from "react-router-dom"
import { NotificationListPanel } from "@/components/header-notifications/NotificationListPanel"
import { UserDisplayOrConnectButton } from "./UserDisplayOrConnectButton"
import { cn } from "@/lib/utils"
import { useIntl } from "react-intl"

const menuPillClass =
  "border-border bg-background flex items-center gap-[18px] rounded-xl border px-3 py-1 shadow-1-light"

const menuTriggerClass =
  "bg-transparent hover:bg-primary-10 flex size-9 shrink-0 items-center justify-center rounded-full border-none p-0 text-primary-text"

interface MobileHeaderProps {
  title: string
  logoAlt: string
  className?: string
}

export function MobileHeader({ title, logoAlt, className }: MobileHeaderProps) {
  const intl = useIntl()

  return (
    <header
      className={cn(
        "relative z-20 flex shrink-0 flex-col gap-6 p-4 lg:px-6",
        className
      )}
    >
      <div className="flex items-center justify-between gap-3">
        <Link
          to={APP_ROUTES.home}
          className="focus-visible:ring-ring flex shrink-0 overflow-hidden rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
          aria-label={intl.formatMessage({ id: "nav.home" })}
        >
          <img
            src={ImgLogoWithFullName}
            alt={logoAlt}
            width={167}
            height={40}
            className="h-10 w-[167px] object-contain object-left"
          />
        </Link>

        <div
          className={cn(menuPillClass)}
          aria-label={intl.formatMessage({ id: "layout.mobileMenu" })}
        >
          <NotificationListPanel triggerClassName={menuTriggerClass} />
          <UserDisplayOrConnectButton
            avatarOnly
            triggerClassName={menuTriggerClass}
          />
          <Link
            to={APP_ROUTES.settings}
            className={cn(menuTriggerClass, "no-underline")}
            aria-label={intl.formatMessage({ id: "nav.settings" })}
          >
            <HugeiconsIcon icon={Icons.Settings02} size={20} />
          </Link>
        </div>
      </div>

      <h1
        className="text-primary-text app-text-headline-small truncate font-semibold"
        title={title}
      >
        {title}
      </h1>
    </header>
  )
}
